import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setPassword } from "../../../redux/slices/authSlice";
import BackButton from "../../../components/BackButton";
import InputField from "../../../components/InputField";
import AuthCard from "../../../components/AuthCard";
import Button from "../../../components/Button";
import RequiredLabel from "../../../components/RequiredLabel";
import { showNotification } from "../../../redux/slices/notificationSlice";
import ErrorText from "../../../components/ErrorText";

export default function SetPassword() {
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const phone = useSelector((state) => state.auth.mobile);
  const { t } = useTranslation();
  const isPasswordValid = pwd.length >= 6;
  const requiredReason = t("pleaseCompleteRequiredFields");

  const handleNext = () => {
    if (!isPasswordValid) {
      setError(t('passwordMinLength'));
      dispatch(
        showNotification({
          message: t('passwordMinLength'),
          type: "error",
        })
      );
      return;
    }

    dispatch(setPassword(pwd));
    dispatch(showNotification({ message: t('passwordSet'), type: "success" }));

    if (phone) {
      navigate("/auth/add-username");
    } else {
      navigate("/auth/add-mobile-number");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <BackButton />
        <h2 className="sub-header mb-4">{t("setYourPassword")}</h2>
        <RequiredLabel htmlFor="set-password" className="mb-2">
          {t("password")}
        </RequiredLabel>
        <InputField
          id="set-password"
          type="password"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          placeholder={t("passwordPlaceholder")}
          required
        />
        {error && <ErrorText>{error}</ErrorText>}
        <Button
          onClick={handleNext}
          className="w-full mt-4"
          disabled={!isPasswordValid}
          disabledReason={!isPasswordValid ? requiredReason : ""}
        >
          {t("next")}
        </Button>
      </AuthCard>
    </div>
  );
}
